import { DeeplinkHandlerInput, DeeplinkHandlerLogInput } from '.'

export const deeplinkUrl = ({ logOutcome }: DeeplinkHandlerLogInput) => ({
  url,
}: DeeplinkHandlerInput) => {
  logOutcome({ isSuccess: true })
  window.location.assign(url)
}
